import { render, staticRenderFns } from "./medicalTemplateList.vue?vue&type=template&id=61947330&scoped=true&"
import script from "./medicalTemplateList.vue?vue&type=script&lang=js&"
export * from "./medicalTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61947330",
  null
  
)

export default component.exports